import { Box, Button, TextField, useMediaQuery } from "@mui/material";
import { useState } from "react";
import swal from "sweetalert";

import Header from "../../components/Header";
import useAuth from "../../auth/useAuth";
import { loginRoute } from "../../config";
import Loading from "../global/Loading";
import Logo from "../../assets/serrano.png";

const DEFAULT_LOGIN_ERROR = "No fue posible iniciar sesión. Intente nuevamente.";

const getErrorMessage = (payload, fallbackText = "") => {
  if (payload && typeof payload === "object") {
    return (
      payload.detail ||
      payload.message ||
      payload.error ||
      fallbackText ||
      DEFAULT_LOGIN_ERROR
    );
  }

  if (typeof payload === "string" && payload.trim() !== "") {
    return payload;
  }

  return fallbackText || DEFAULT_LOGIN_ERROR;
};

const parseJsonResponse = (rawResponse) => {
  if (!rawResponse) return null;

  try {
    return JSON.parse(rawResponse);
  } catch {
    return null;
  }
};

const LogIn = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const auth = useAuth();

  const [body, setBody] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setBody({
      ...body,
      [e.target.name]: e.target.value,
    });
  };

  const mostrarAlerta = (mensaje) => {
    swal({
      title: "Error:",
      text: mensaje || DEFAULT_LOGIN_ERROR,
      icon: "error",
      button: "Aceptar",
    });
  };

  const asyncsend = async (payloadBody) => {
    try {
      setLoading(true);

      const response = await fetch(loginRoute(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payloadBody),
      });

      const rawResponse = await response.text();
      const payload = parseJsonResponse(rawResponse);

      if (!response.ok) {
        mostrarAlerta(getErrorMessage(payload, rawResponse));
        return;
      }

      if (!payload || typeof payload !== "object") {
        mostrarAlerta("La respuesta del servidor no es válida para iniciar sesión.");
        return;
      }

      if (
        !payload.token ||
        !payload.user ||
        !payload.email ||
        !payload.id ||
        !payload.name_role
      ) {
        mostrarAlerta("La respuesta del servidor no es válida para iniciar sesión.");
        return;
      }

      auth.login(
        payload.token,
        payload.user,
        payload.email,
        payload.id,
        payload.id_role,
        payload.name_role,
        [],
        Array.isArray(payload.companies) ? payload.companies : []
      );
    } catch (e) {
      mostrarAlerta(getErrorMessage(null, e.message));
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;

  return (
    <Box m="10px" display="flex" justifyContent="space-around">
      <Box width="400px">
        <Box display="flex" justifyContent="center" alignItems="center" mb="50px" mt="50px">
          <img
            alt="profile-user"
            width="90%"
            height="90%"
            src={Logo}
            style={{ cursor: "pointer" }}
          />
        </Box>

        <Header title="Ingreso" subtitle="Accede a tu cuenta" />

        <form
          className="LogIn"
          onSubmit={(e) => {
            e.preventDefault();
            asyncsend(body);
          }}
        >
          <Box
            display="grid"
            gap="10px"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            sx={{
              "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
            }}
          >
            <TextField
              fullWidth
              variant="filled"
              type="text"
              label="Email"
              onChange={handleChange}
              value={body.email}
              name="email"
              sx={{ gridColumn: "span 4" }}
            />

            <TextField
              fullWidth
              variant="filled"
              type="password"
              label="Password"
              onChange={handleChange}
              value={body.password}
              name="password"
              sx={{ gridColumn: "span 4" }}
            />
          </Box>

          <Box display="flex" justifyContent="end" mt="15px">
            <Button color="secondary" variant="contained" type="submit">
              Sign In
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default LogIn;